// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable init-declarations, default-case, no-alert, no-console */
import * as R from "ramda"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"

export const testUsers = [
  // Test account first
  { email: "test@kiwi.com", password: "" },
  // Rest sorted alphabetically
  { email: "adam.allshare@kiwi.com", password: "" },
  { email: "alzbeta.palowska@skypicker.com", password: "" },
  { email: "andrea.mozova@kiwi.com", password: "" },
  { email: "domi@kiwi.com", password: "" },
  { email: "ellie@kiwi.com", password: "" },
  { email: "internal_partner@kiwi.com", password: "" },
  { email: "meme.maister@kiwi.com", password: "" },
  { email: "michal.banas@kiwi.com", password: "" },
  { email: "natalia.vajdova@kiwi.com", password: "" },
  { email: "rozok@kiwi.com", password: "" },
  { email: "sarka.chwastkova@kiwi.com", password: "" },
  { email: "translator@kiwi.com", password: "" },
]

function fillForm(def) {
  R.forEachObjIndexed((val, sel) => {
    const el = document.querySelector(sel)
    el.value = val
    el.dispatchEvent(new Event("input", { bubbles: true }))
  }, def)
}

const TAB_TYPES = {
  ONE_BOOKING: "myBooking",
  SIGN_UP: "register",
  SIGN_IN: "signIn",
}

export function smartFill(preparedUser) {
  cuckoo.disable()
  const state = window.reduxStore.getState()

  // Detect what form to fill
  const OPTIONS = {
    RESERVATION: "RESERVATION",
    LOGIN_PASSWORD: "LOGIN_PASSWORD",
    LOGIN_BOOKING: "LOGIN_BOOKING",
    SIGNUP: "SIGNUP",
  }

  let option

  if (state.modals.hasIn(["login", "activeTab"])) {
    const activeTab = state.modals.getIn(["login", "activeTab"])
    switch (activeTab) {
      case TAB_TYPES.SIGN_IN:
        option = OPTIONS.LOGIN_PASSWORD
        break
      case TAB_TYPES.ONE_BOOKING:
        option = OPTIONS.LOGIN_BOOKING
        break
      case TAB_TYPES.SIGN_UP:
        option = OPTIONS.SIGNUP
        break
    }
  } else {
    const page = state.page.get("name")
    switch (page) {
      case "search":
        break
      case "booking":
        option = OPTIONS.RESERVATION
        break
    }
  }

  let user = preparedUser
  const mapIndexed = R.addIndex(R.map)

  if (!user) {
    const usersString = R.compose(
      R.join("\n"),
      mapIndexed((x, i) => `${i}: ${x.email}`),
    )(testUsers)
    const userIndex = window.prompt(usersString, 0)
    user = testUsers[userIndex] || testUsers[0] // safe default
  }

  // Constants for different age groups
  const currentYear = new Date().getFullYear()
  const adultThreshold = 18
  const childThreshold = 2
  const adultYear = currentYear - adultThreshold - 1 // Above adult threshold
  const childYear = currentYear - childThreshold - 1 // Above child threshold
  const infantYear = currentYear // Below child threshold

  // passengers[] means, it will be filled for all passengers
  // passengers[INDEX] means it will only be used for INDEX passenger
  // If no passenger is found for INDEX, the value won't be used
  // Specific values (with INDEX) override global values

  const FIRST_PAP = {
    firstname: "TEST",
    lastname: "TEST",
    nationality: "gb",
    birthDay: "1",
    title: "mr",
    birthMonth: "1",
    birthYear: adultYear,
    idNumber: "12345678XY",
    idExpirationDay: "24",
    idExpirationMonth: "12",
    idExpirationYear: "2024",
    insurance: "none",
    baggage: { handBag: 0, holdBag: 0 },
  }

  const VALUES = {
    passengers: [
      FIRST_PAP,
      {
        ...FIRST_PAP,
        firstname: "Test Second",
        lastname: "Test Second",
        title: "ms",
        birthDay: "1",
        birthYear: childYear,
      },
      {
        ...FIRST_PAP,
        firstname: "Test Third",
        lastname: "Test Third",
        birthDay: "1",
        birthYear: infantYear,
      },
      { ...FIRST_PAP, firstname: "Test Fourth", lastname: "Test Fourth" },
      { ...FIRST_PAP, firstname: "Test Fifth", lastname: "Test Fifth" },
      { ...FIRST_PAP, firstname: "Test Sixth", lastname: "Test Sixth" },
      { ...FIRST_PAP, firstname: "Test Seventh", lastname: "Test Seventh" },
      { ...FIRST_PAP, firstname: "Test Eighth", lastname: "Test Eighth" },
      { ...FIRST_PAP, firstname: "Test Ninth", lastname: "Test Ninth" },
    ],
    contact: {
      email: user.email,
      phone: "555",
    },
    billingDetails: {
      address: "85 Albert Embankment",
      city: "London",
      postalCode: "10200",
      country: "gb",
      companyName: "MI6",
      companyId: "10006",
      companyVat: "UK 753215448",
      firstName: "TEST",
      lastName: "APPROVE",
      idNumber: "304.620.422-19",
      type: "PERSON",
    },
    agreements: {
      terms: true,
    },
  }

  switch (option) {
    case OPTIONS.LOGIN_PASSWORD:
      fillForm({
        ".LoginSignupModal [name=email]": user.email,
        ".LoginSignupModal [name=password]": user.password,
      })
      break

    default:
      console.assert(false, `Unknown smartFill option: ${option}`)
  }

  setTimeout(() => {
    cuckoo.enable()
  }, 2000) // Give browser some time
}
